import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Stack,
  InputAdornment,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import BarcodeScanner, { BarcodeFormat } from "react-qr-barcode-scanner";

/**
 * Props:
 * - open: boolean
 * - slotId: string | number
 * - slotLabel: string
 * - initialValues?: { nombre?: string, documento?: string }  // para ocupar o para liberar (puede venir prellenado)
 * - onCancel: () => void
 * - onConfirm: (payload: { slotId, slotLabel, nombre, documento }) => void
 */
export default function ScanDNIDialog({
  open,
  onCancel,
  onConfirm,
}) {
  const [data, setData] = React.useState('');
  const [torchOn, setTorchOn] = React.useState(false);

  const handleConfirmar = () => {
    onConfirm?.(data);
  };

  React.useEffect(() => {
    if (!!data) {
      alert(data);
    }
  }, [data]);

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      fullWidth
      maxWidth="sm"
      sx={{zIndex: 10}}
      PaperProps={{ sx: { borderRadius: 2 } }}
    >
      <DialogTitle sx={{ pr: 6 }}>
        Lectura de DNI
        <IconButton
          onClick={onCancel}
          aria-label="Cerrar"
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography variant="body2" color="text.secondary">
            Ubique el Código de barras dentro del recuadro
          </Typography>

          <BarcodeScanner torch={torchOn} formats={[BarcodeFormat.PDF_417]} onUpdate={(err, result) => {
          if (result) setData(result.text);
          else setData('');
        }}/>
        </Stack>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={() => {setTorchOn(!torchOn)}} variant="outlined">
          Luz
        </Button>
        <Button onClick={onCancel} variant="outlined">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
